// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__QQuaw","errorLogs":"EditorFooter_errorLogs__1UaOX"};